(() => {
  'use strict';
  if (window.DFFreeFunnel) return;
  window.DFFreeFunnel = Object.freeze({ version: 1 });

  function boot() {
    const roots = document.querySelectorAll('[data-df-free-funnel]');
    if (roots.length !== 1) return;
    const root = roots[0];
    if (root.dataset.dfFreeReady) return;
    const node = root.querySelector('script[data-df-free-config]');
    if (!node) return;
    let config;
    let current;
    let apiRoot;
    let productPath;
    try {
      config = JSON.parse(node.textContent);
      current = new URL(window.location.href);
      const storefront = config?.scope === 'storefront';
      const publicPages = ['index', 'product', 'collection', 'list-collections', 'search', 'page', 'blog', 'article', 'policy', 'cart', '404', 'metaobject'];
      if (!config || config.enabled !== true || (storefront ? !publicPages.includes(config.pageType) :
          (config.scope !== undefined && config.scope !== 'free-offer') || config.pageType !== 'index' || config.templateSuffix !== 'free-offer') ||
          config.designMode !== false || config.visualPreview !== false || window.Shopify?.designMode || window.Shopify?.inspectMode ||
          !['https:', 'http:'].includes(current.protocol) || (current.protocol === 'http:' && !['localhost', '127.0.0.1', '[::1]'].includes(current.hostname)) ||
          current.username || current.password || config.origin !== current.origin || config.path !== current.pathname ||
          typeof config.rootPath !== 'string' || !/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8}){0,2}\/?)?$/.test(config.rootPath) ||
          !/^\d{1,20}$/.test(String(config.variantId)) || typeof config.requiresShipping !== 'boolean' ||
          (config.requiresShipping && config.shippingDisclosed !== true)) return;
      apiRoot = config.rootPath.replace(/\/?$/, '/');
      const isHome = [apiRoot, apiRoot.replace(/\/$/, '') || '/'].includes(current.pathname);
      if ((!storefront || config.pageType === 'index') && !isHome) return;
      let decodedPath = current.pathname;
      for (let pass = 0; pass < 3; pass++) {
        const decoded = decodeURIComponent(decodedPath);
        if (decoded === decodedPath) break;
        decodedPath = decoded;
      }
      if (/[\\\u0000-\u0020\u007f%]/.test(decodedPath) || (!isHome && !decodedPath.startsWith(apiRoot))) return;
      const localPath = isHome ? '' : decodedPath.slice(apiRoot.length);
      const privatePath = /^(?:account|accounts|customers|orders?|checkouts?|password|gift[-_]cards?|d|library|downloads?|apps|a|tools|services|challenge|authentication|customer_authentication|identity|auth|login|logout|register|recover|reset|activate|payments?|pay)(?:[/.]|$)/i;
      if (privatePath.test(localPath) || privatePath.test(decodedPath.slice(1))) return;
      if (/%(?![0-9a-f]{2})/i.test(current.search) || /[\u0000-\u0020\u007f]/.test(current.search)) return;
      const names = new Set();
      for (const [key, value] of current.searchParams) {
        const name = key.toLowerCase();
        if (!key || names.has(name) || /[\u0000-\u001f\u007f\[\]]/.test(key + value) ||
            /(?:key|token|nonce|secret|password)/i.test(name) ||
            ['section_id', 'sections', 'design_mode', 'shopify_design_mode', 'shopify_editor', 'df_free', 'return_to', 'return_url', 'redirect', 'redirect_url', 'checkout', 'cart', 'account'].includes(name)) return;
        names.add(name);
      }
      if (!storefront && current.searchParams.get('view') !== 'free-offer') return;
      if (typeof config.productPath !== 'string') return;
      const localProduct = config.productPath.startsWith(apiRoot + 'products/') ? config.productPath.slice(apiRoot.length) : config.productPath.slice(1);
      if (!/^products\/[a-z0-9][a-z0-9-]*$/.test(localProduct)) return;
      productPath = apiRoot + localProduct + '.js';
    } catch { return; }

    root.dataset.dfFreeReady = 'true';
    const status = root.querySelector('[data-df-free-status]');
    const controls = [...root.querySelectorAll('[data-df-free-claim] [type="submit"]')];
    const disabled = controls.map(button => button.disabled);
    const id = String(config.variantId);
    const marker = 'df_free_claim_' + id;
    const ownership = 'v1:' + id;
    const setState = state => {
      root.dataset.dfFreeState = state;
      if (status) {
        const key = 'dfFree' + state[0].toUpperCase() + state.slice(1);
        status.textContent = status.dataset?.[key] || root.dataset[key] || (['seen', 'manual'].includes(state) ? status.dataset?.dfFreeSkipped || root.dataset.dfFreeSkipped : '') || '';
      }
    };
    const managedSingleCopy = window.DFCart?.singleCopyManaged === true;
    if (typeof window.DFCart?.runExclusive !== 'function' || (!managedSingleCopy && typeof window.navigator?.locks?.request !== 'function') ||
        (managedSingleCopy && !/^\d{1,20}$/.test(String(config.productId)))) {
      setState('manual');
      return;
    }

    async function request(path, body) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(path, {
          method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal,
          headers: body === undefined ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
          ...(body === undefined ? {} : { body: JSON.stringify(body) })
        });
        if (!response.ok) throw new Error('Free item request failed.');
        return await response.json();
      } finally { clearTimeout(timer); }
    }

    function cartState(cart) {
      if (!cart || typeof cart.token !== 'string' || !cart.token || cart.token.length > 1024 || !Array.isArray(cart.items) ||
          !cart.attributes || typeof cart.attributes !== 'object' || Array.isArray(cart.attributes)) throw new Error('Invalid cart.');
      return cart;
    }
    const readCart = async () => cartState(await request(apiRoot + 'cart.js'));
    function eligible(product) {
      if ((managedSingleCopy && String(product?.id) !== String(config.productId)) || !product || !Array.isArray(product.variants) || product.requires_selling_plan === true || (product.selling_plan_groups?.length || 0) > 0) return false;
      const variant = product.variants.find(variant => String(variant.id) === id);
      return !!variant && variant.available === true && variant.price === 0 && variant.requires_shipping === config.requiresShipping &&
        variant.requires_selling_plan !== true && !(variant.selling_plan_allocations?.length > 0);
    }
    const matching = cart => cart.items.filter(item => String(item.variant_id || item.id) === id);
    const alternative = cart => managedSingleCopy && !matching(cart).length && cart.items.some(item => String(item.product_id) === String(config.productId));
    const ownLines = cart => matching(cart).filter(item => item.properties?._df_free_campaign === ownership);
    function safeLine(item) {
      return (!managedSingleCopy || String(item.product_id) === String(config.productId)) && item.price === 0 && item.requires_shipping === config.requiresShipping && !item.selling_plan_allocation &&
        ['original_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price'].every(key => item[key] === undefined || item[key] === 0);
    }
    async function present(cart) {
      if (!eligible(await request(productPath)) || matching(cart).some(item => !safeLine(item))) throw new Error('Review the changed free offer.');
      return { state: 'present' };
    }

    async function claim() {
      const before = await readCart();
      if (before.attributes[marker]) return alternative(before) ? { state: 'alternate' } : matching(before).length ? present(before) : { state: 'seen' };
      if (!eligible(await request(productPath))) throw new Error('The free offer changed.');
      const marked = cartState(await request(apiRoot + 'cart/update.js', { attributes: { [marker]: 'attempted-v1' } }));
      if ((marked.token !== before.token && (before.items.length !== 0 || Object.keys(before.attributes).length !== 0 || marked.items.length !== 0)) || marked.attributes[marker] !== 'attempted-v1') throw new Error('The cart changed.');
      const expectedToken = marked.token;
      if (alternative(marked)) return { state: 'alternate' };
      if (matching(marked).length) return present(marked);
      if (!eligible(await request(productPath))) throw new Error('The free offer changed.');
      const latest = await readCart();
      if (latest.token !== expectedToken || latest.attributes[marker] !== 'attempted-v1') throw new Error('The cart changed.');
      if (alternative(latest)) return { state: 'alternate' };
      if (matching(latest).length) return present(latest);
      const previousKeys = new Set(latest.items.map(item => item.key));
      try {
        await request(apiRoot + 'cart/add.js', { items: [{ id, quantity: 1, properties: { _df_free_campaign: ownership } }] });
      } catch {
      }
      const after = await readCart();
      if (after.token !== expectedToken) throw new Error('The cart changed.');
      const owned = ownLines(after).filter(item => !previousKeys.has(item.key));
      const stillEligible = eligible(await request(productPath));
      if (owned.length !== 1 || owned[0].quantity !== 1 || !safeLine(owned[0]) || !stillEligible) {
        if (owned.length === 1 && owned[0].quantity === 1 && typeof owned[0].key === 'string' && owned[0].key) {
          await request(apiRoot + 'cart/change.js', { id: owned[0].key, quantity: 0 });
        }
        throw new Error('Review the changed free offer.');
      }
      return { state: 'added', added: true };
    }

    setState('pending');
    controls.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const operation = () => managedSingleCopy ? window.DFCart.runExclusive(claim) : window.navigator.locks.request('df-free-funnel-v1', { ifAvailable: true }, lock => {
      if (!lock) return { state: 'manual' };
      return window.DFCart.runExclusive(claim);
    });
    Promise.resolve().then(operation).then(async result => {
      if (managedSingleCopy && ['added', 'present'].includes(result?.state)) {
        const confirmed = await readCart();
        if (alternative(confirmed)) result = { state: 'alternate' };
        else if (!matching(confirmed).length) result = { state: 'seen' };
        else await present(confirmed);
      }
      setState(result?.state || 'manual');
    }).catch(() => setState('error')).finally(() => {
      controls.forEach((button, index) => { button.disabled = disabled[index]; button.removeAttribute('aria-busy'); });
    });
  }

  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot, { once: true });
})();
